import { PolygonLines } from '@App/app/entities/layer/polygons/polygon-lines.model';
import { ViewerPolygonLayer } from '@App/app/entities/layer/polygons/polygon.model';
import { Injectable } from '@angular/core';
import { Mesh, TransformNode, Vector3 } from 'babylonjs';
import { CENTER_SPHERES_CONTAINER_NAME } from '@App/app/configs/babylon.config';
import { GenerateGUIService } from '../../gui-services/generate-gui-service/generate-gui.service';
import { PolygonMathService } from './polygon-math.service';
import { PolygonMeshService } from './polygon-mesh.service';

@Injectable({
  providedIn: 'root',
})
export class PolygonLinesService {
  constructor(
    private generateGUIService: GenerateGUIService,
    private polygonMeshService: PolygonMeshService,
    private polygonMathService: PolygonMathService,
  ) {}

  createPolygonLinesDescription(
    polygonMesh: Mesh,
    pointsMeshes: Mesh[],
    root: TransformNode,
    visible: boolean,
  ): PolygonLines {
    const positionsArr = this.clonePositions(pointsMeshes);
    const polygonsLinesLength = this.polygonMathService.calculateLineLengths(positionsArr);
    const polygonsLinesCenters = this.polygonMathService.calculateLineCenters(
      positionsArr,
      polygonMesh.position.y,
    );

    const centerSpheresContainer = root
      .getChildren()
      .filter((mesh) => mesh.id === CENTER_SPHERES_CONTAINER_NAME);

    const polygonsSphereCenters = polygonsLinesCenters.map((center) => {
      const centerSphere = this.polygonMeshService.initCenterSphere(center);
      centerSphere.parent = centerSpheresContainer.length !== 0 ? centerSpheresContainer[0] : root;

      return centerSphere;
    });

    const polygonsText = polygonsSphereCenters.map((center, i) =>
      this.generateGUIService.createLengthTag(center, polygonsLinesLength[i], visible),
    );

    return {
      polygonsLinesLength,
      polygonsLinesCenters,
      polygonsSphereCenters,
      polygonsText,
    };
  }

  movePolygonLines(polygon: ViewerPolygonLayer) {
    if (!polygon.mesh) {
      return;
    }
    const positionsArr = this.clonePositions(polygon.pointsMeshes);
    const polygonsLinesCenters = this.polygonMathService.calculateLineCenters(
      positionsArr,
      polygon.mesh.position.y,
    );
    polygon.polygonLines.polygonsSphereCenters.forEach((sphere, i) => {
      sphere.position = polygonsLinesCenters[i];
    });
  }

  private clonePositions(meshes: Mesh[]): Vector3[] {
    return meshes.map((mesh) => mesh.position.clone());
  }
}
